/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */
'use strict';
angular.module('prism-ui.components').service('SearchFilterService', function ($location, $q, moment, UsersResourceFactory, EnumService) {
	var self = this;
	var CONTENT_TYPES = ['Ad/PreRoll', 'Movie/Special', 'Series'];

	var normalizeCriteriaBody = function (param) {
		if (typeof param === 'string') {
			return [param];
		}
		else if (!param) {
			return null;
		}
		return param;
	};

	self.defaultWorkflowCriteria = {
		dateProperty: '',
		contentType: null,
		fromDate: null,
		toDate: null,
		recentDays: 14,
		status: ['EXECUTING', 'FAILED', 'PAUSED', 'QUEUED', 'STALLED', 'WAITING', 'CREATED'],
		submitters: null
	};

	self.defaultPackageCriteria = {
		dateProperty: null,
		keywords: null,
		fromDate: null,
		toDate: null,
		packageProperties: ['episodeTitle', 'id', 'name']
	};

	self.defaultBaseCriteria = {
		dateProperty: $location.path().indexOf('system/partners') < 0 ? 'lastXDays' : null,
		contentType: null,
		keywords: null,
		fromDate: null,
		toDate: null,
		recentDays: 7
	};


	self.workflowSearchCriteria = angular.copy(self.defaultWorkflowCriteria);
	self.searchCriteria = angular.copy(self.defaultPackageCriteria);
	self.baseCriteria = angular.copy(self.defaultBaseCriteria);

    var isSearchingForPackages = function () {
        return $location.path().indexOf('/package') > -1;
    };

    var isSearchingForWorkflows = function () {
        // Regex: Last part of url == 'workflows' (with optional '/')
        //        followed by query parameters '?' or anchor '#'
        return $location.path().match('dashboard/workflows/?([?#]|$)');
    };

	self.getCurrentSearchCriteria = function () {
		if (isSearchingForWorkflows()) {
			return self.workflowSearchCriteria;
		} else if(isSearchingForPackages()) {
			return self.searchCriteria;
		} else {
			return self.baseCriteria;
		}
	};

	self.updateLocationSearch = function () {
        //
        // I believe this is needed because `searchText` and
        // `keywords` have been interchanged and conflated.
        //
        var packageSearchText = $location.search().searchText;

        $location.search('searchText', self.getCurrentSearchCriteria().keywords);
		$location.search('dateType', self.getCurrentSearchCriteria().dateProperty);
		$location.search('startDate', (self.getCurrentSearchCriteria().fromDate) ? moment(self.getCurrentSearchCriteria().fromDate).format('MM-DD-YYYY') : null);
		$location.search('endDate', (self.getCurrentSearchCriteria().toDate) ? moment(self.getCurrentSearchCriteria().toDate).format('MM-DD-YYYY') : null);
		$location.search('contentType', self.getCurrentSearchCriteria().contentType);
		$location.search('network', self.getCurrentSearchCriteria().network);
		$location.search('categoryType', self.getCurrentSearchCriteria().categoryType);
		$location.search('category', self.getCurrentSearchCriteria().category);
		$location.search('content', self.getCurrentSearchCriteria().content);
		$location.search('season', self.getCurrentSearchCriteria().season);
		$location.search('volume', self.getCurrentSearchCriteria().volume);
        $location.search('delivered', self.getCurrentSearchCriteria().delivered);
        $location.search('deliveredToPartners', self.getCurrentSearchCriteria().deliveredToPartners);
		if (isSearchingForWorkflows()) {
			$location.search('recentDays', self.getCurrentSearchCriteria().recentDays);
			$location.search('submitters', self.getCurrentSearchCriteria().submitters);
			$location.search('status', self.getCurrentSearchCriteria().status);
			$location.search('packageProperties', null);
			$location.search('partnerProperties', null);
		} else if (isSearchingForPackages()){
            if (packageSearchText) {
                $location.search('searchText', packageSearchText);
            }
			$location.search('packageProperties', self.getCurrentSearchCriteria().packageProperties);
			$location.search('partnerProperties', self.getCurrentSearchCriteria().partnerProperties);
			$location.search('externalSystem', self.getCurrentSearchCriteria().externalSystem);
			$location.search('recentDays', null);
			$location.search('submitters', null);
			$location.search('status', null);
		}
	};

	self.populateCriteriaFromLocationSearch = function () {
		var searchParams = $location.search();

		self.getCurrentSearchCriteria().keywords = searchParams.searchText;
		self.getCurrentSearchCriteria().dateProperty = searchParams.dateType;
		self.getCurrentSearchCriteria().fromDate = (searchParams.startDate)? new Date(searchParams.startDate) : null;
		self.getCurrentSearchCriteria().toDate = (searchParams.endDate)? new Date(searchParams.endDate) : null;
		self.getCurrentSearchCriteria().contentType = searchParams.contentType || null;
		self.getCurrentSearchCriteria().categoryType = normalizeCriteriaBody(searchParams.categoryType);
		self.getCurrentSearchCriteria().category = normalizeCriteriaBody(searchParams.category);
		self.getCurrentSearchCriteria().network = normalizeCriteriaBody(searchParams.network);
		self.getCurrentSearchCriteria().content = normalizeCriteriaBody(searchParams.content);
		self.getCurrentSearchCriteria().season = normalizeCriteriaBody(searchParams.season);
		self.getCurrentSearchCriteria().volume = normalizeCriteriaBody(searchParams.volume);
        self.getCurrentSearchCriteria().delivered = searchParams.delivered;
        self.getCurrentSearchCriteria().deliveredToPartners = normalizeCriteriaBody(searchParams.deliveredToPartners);
		if (isSearchingForWorkflows()) {
			self.getCurrentSearchCriteria().recentDays = searchParams.recentDays;
			self.getCurrentSearchCriteria().submitters = normalizeCriteriaBody(searchParams.submitters);
			self.getCurrentSearchCriteria().status = normalizeCriteriaBody(searchParams.status);
		} else if (isSearchingForPackages()) {
			self.getCurrentSearchCriteria().packageProperties = normalizeCriteriaBody(searchParams.packageProperties);
			self.getCurrentSearchCriteria().partnerProperties = normalizeCriteriaBody(searchParams.partnerProperties);
			self.getCurrentSearchCriteria().externalSystem = normalizeCriteriaBody(searchParams.externalSystem);
		}
	};

	self.setSearchCriteriaForQueryOpts = function () {

		var theQueryOpts = {};
		if (self.workflowSearchCriteria.dateProperty === 'startDate') {
			theQueryOpts.dateProperty = self.workflowSearchCriteria.dateProperty;
			if (self.workflowSearchCriteria.fromDate) {
                self.workflowSearchCriteria.fromDate.setHours(0);
                theQueryOpts.fromDate = self.workflowSearchCriteria.fromDate.toString();
            }
			if (self.workflowSearchCriteria.toDate) {
                self.workflowSearchCriteria.toDate.setHours(23);
                theQueryOpts.toDate = self.workflowSearchCriteria.toDate.toString();
            }
		}
		if (self.workflowSearchCriteria.dateProperty === 'lastXDays') {
			var xDays = new Date();
			xDays.setDate(xDays.getDate() - self.workflowSearchCriteria.recentDays);
			theQueryOpts.dateProperty = 'dateCreated';
			theQueryOpts.fromDate = xDays.toString();
			theQueryOpts.toDate = new Date().toString();
		}
		if (self.workflowSearchCriteria.submitters) {
			theQueryOpts.submittedByUserId = self.workflowSearchCriteria.submitters;
		}
		if (self.workflowSearchCriteria.status) {
			theQueryOpts.status = self.workflowSearchCriteria.status;
		}
		if (self.workflowSearchCriteria.submitters) {
			theQueryOpts.submittedByUserId = self.workflowSearchCriteria.submitters;
		}
		theQueryOpts.searchString = self.workflowSearchCriteria.keywords;
		theQueryOpts.categoryType = self.workflowSearchCriteria.categoryType;
		theQueryOpts.category = self.workflowSearchCriteria.category;
		theQueryOpts.network = self.workflowSearchCriteria.network;
		theQueryOpts.contentName = self.workflowSearchCriteria.content;

		return theQueryOpts;
	};

	self.resetCriteriaToDefault = function () {
		if (isSearchingForWorkflows()) {
			self.workflowSearchCriteria = angular.copy(self.defaultWorkflowCriteria);
		} else if (isSearchingForPackages()) {
			self.searchCriteria = angular.copy(self.defaultPackageCriteria);
		} else {
			self.baseCriteria = angular.copy(self.defaultBaseCriteria);
		}
		self.updateLocationSearch();
	};

	self.isSearchFilterApplied = function () {
		if (isSearchingForWorkflows()) {
			return self.workflowSearchCriteria.dateProperty || self.workflowSearchCriteria.submitters || self.workflowSearchCriteria.contentType ||
				self.workflowSearchCriteria.fromDate || self.workflowSearchCriteria.toDate || self.workflowSearchCriteria.status;
		} else {
			return self.getCurrentSearchCriteria().keywords ||
                self.getCurrentSearchCriteria().dateProperty ||
                self.getCurrentSearchCriteria().contentType ||
                self.getCurrentSearchCriteria().delivered;
		}
	};

	self.extractQueryProp = function (collection, modelProp) {
		var returnVal = [];
		angular.forEach(collection, function (item) {
			returnVal.push(item[modelProp]);
		});
		return returnVal;
	};

	self.getObjectsFromPathProp = function (collection, objectProp, pathParam) {
		var objects = [];
		var pathValue = $location.search()[pathParam];
		if (typeof pathValue === 'string') {
			pathValue = [pathValue];
		}
		angular.forEach(pathValue, function (entry) {
			for (var i = 0; i < collection.length; i++) {
				var collectionObj = collection[i];
				if (collectionObj[objectProp] === entry) {
					objects.push(collectionObj);
					break;
				}
			}
		});
		return objects;
	};

	self.getSubmitters = function () {
		return UsersResourceFactory.query({fetchLimit: 10000}).$promise;
	};

	self.getContentTypes = function () {
		var defferred = $q.defer();
		defferred.resolve(CONTENT_TYPES);
		return defferred.promise;
	};

	self.getWorkflowStatuses = function () {
		var defferred = $q.defer();
		EnumService.queryForEnums().then(() => {
    		defferred.resolve(EnumService.getEnumPicklist('WorkflowExecution_status'));
        });
		return defferred.promise;
	};
});
